import React from 'react';

const TermsOfServiceKO = () => {
  return (
    <>
      <b>제 1조 목적</b>
      <br />
      본 서비스 약관은 뮤빗 (이하 ‘서비스’)에 적용됩니다. 여기에는 ㈜블렌딩 (이하 ‘회사’)에서 개발하고 배열한 다양한 웹
      사이트, API, 응용 프로그램 및 버튼이 포함됩니다.
      <br />
      서비스 약관의 목적은 회사와 서비스 사용자 (이하 ‘회원’)의 권리, 의무 및 책임을 명확하게 정의하는 것입니다. 본
      서비스 약관은 회원의 법적 권리 및 의무에 영향을 미칩니다.
      <br />
      본 서비스 약관 또는 서비스와 관련하여 질문, 의견이 있으시면 support@mubeat.tv 로 문의해 주십시오.
      <br />
      <br />
      <b>제 2조 정의</b>
      <br />이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
      <ol>
        <li>
          서비스라 함은 회사가 회원에게 직접 또는 제휴사와 함께 제공하는 KPOP 관련 클립 영상과 다양한 저작물에 제공을
          하는 스마트폰 단말기 어플리케이션을 뜻합니다.
        </li>
        <li>회원이란 본 약관에 따라 회사와 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 고객을 의미합니다.</li>
        <li>
          아이디(ID)란 회원식별과 서비스를 이용하기 위하여 회원이 정하고 회사가 승인하는 이메일 또는 각종 SNS 고유코드의
          문자조합을 의미합니다.
        </li>
        <li>
          비밀번호란 회원이 부여 받은 아이디와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는
          숫자의 조합을 의미합니다.
        </li>
        <li>
          개인 프로필이란 이용자 식별을 위해 부여한 ID 및 서비스 내에서의 닉네임 등을 의미하며, 이용자가 설정한 사진,
          도화 등의 프로필 사진을 포함합니다.
        </li>
        <li>
          게시물이란 회원이 서비스를 이용함에 있어 서비스 상에 게시한 텍스트, 그래픽, 데이터, 기사, 사진, 이미지,
          일러스트레이션, 동영상, 첨부파일, 링크 등의 사용자 제출물을 의미합니다.
        </li>
        <li>
          유료회원이란 별도의 금액을 지불하고 월 정기 이용권, 유료 충전 상품 구매 등을 결제하여 유료서비스를 이용하는
          회원을 의미합니다.
        </li>
        <li>
          유료서비스란 회사가 제공하는 서비스 중 회원이 회사에 일정 금액을 결제하거나, 회원이 회사의 거래 내지 약정
          조건을 수락하는 경우에 이용할 수 있는 회사의 서비스를 의미합니다.
        </li>
        <li>
          비트란 회원이 서비스를 이용함에 있어 광고시청, 유 무료 충전소, 기타 서비스 이용 등 을 통하여 적립 및
          구매하거나, 회사가 시행하는 프로모션, 이벤트, 기타 거래 동의, 조건 이행 등의 대가, 환급수단으로 지급 받는 자체
          포인트를 말합니다.
        </li>
        <li>
          팬덤광고란 다수의 회원이 팬덤 모금을 통해 좋아하는 아티스트의 기념일을 축하 할 수 있는 서비스를 말합니다.
        </li>
      </ol>
      <b>제 3조 서비스 이용 주체</b>
      <br />
      회원은 ㈜블렌딩과 구속력 있는 계약을 체결하기로 동의하고 해당 관할 지역의 법률에 따라 서비스를 받는 것이 금지된
      자가 아닐 경우에만 본 서비스를 사용할 수 있습니다.
      <ol>
        <li>
          EU GDPR 개정 시행 국가에서 서비스에 액세스하거나 서비스를 이용하여 16세 이상 (또는 상위 국가인 경우 법정 성년
          이상)이고 회사의 서비스 약관을 준수할 수 있는 능력이 있고 자격이 있음을 확인합니다. 해당하는 경우 회원이 16세
          미만인 경우 서비스 등록을 시도하거나 개인 정보를 회사에 보내지 않아야 합니다. 회사는 회원이 16세 미만이고
          서비스를 사용할 수 없는 경우에도 서비스를 사용하고 있음을 알게 되면 계정을 비활성화하고 삭제합니다.
        </li>
        <li>
          각 국가별 개별 법률을 통하여 부모 등 법정대리인의 동의를 요구하는 아동 연령 기준을 만 13세까지 낮추어
          규정할수가 있습니다. 개인 정보의 수집 및 이용목적에 대하여 충분히 숙지하고 부모 등의 법정대리인의 동의를 얻은
          후에 회원가입을 신청해야합니다. 또한 부모 등 법정 대리인은 아동에 대한 개인정보의 열람, 정정, 갱신을
          요청하거나 회원가입에 대한 동의를 철회할 수 있으며 이러한 경우에 회사는 지체 없이 필요한 조치를 취해야 합니다.
        </li>
      </ol>
      부모가 필요한 최소 연령 미만의 어린이가 개인 정보를 제공했다고 생각되는 경우 support@mubeat.tv 로 문의해 주십시오.
      <br />
      <br />
      <b>제 4조 개인정보</b>
      <br />
      회사는 회원의 개인 정보를 매우 중요하게 생각합니다. 개인정보처리방침은 회사가 서비스를 사용할 때 회원이 제공 한
      정보를 처리하는 방법을 설명합니다. 회원은 서비스를 사용함으로써 회사와 그 계열사가 사용하기 위해 이 정보의 수집 및
      사용 (개인정보처리방침에 명시된)에 동의한다는 것을 이해해야 합니다.
      <br />
      <br />
      <b>제 5조 회원 계정</b>
      <br />
      회원은 서비스 중 일부를 이용하기 위해 계정 생성, 이메일 주소 및 비밀번호를 포함하되 이에 국한되지 않는 특정 정보를
      회사에 제공해야 합니다. 회원은 회원이 생성한 계정을 보호할 책임이 있으며, 따라서 강력한 비밀번호를 사용하고 해당
      계정으로만 사용을 제한하기 바랍니다. 회사는 회원이 위의 조항을 준수하지 않음으로 인해 발생하는 손실 및 손해에 대해
      어떠한 경우에도 책임지지 않습니다.
      <br />
      <br />
      <b>제 6조 약관의 효력 및 변경</b>
      <ol>
        <li>
          본 약관은 이용자가 회원으로 등록됨과 동시에 효력을 발생하며, 이용자의 서비스 탈퇴와 동시에 효력을 다합니다.
        </li>
        <li>
          본 약관은 어플리케이션 &gt; 설정 &gt; 이용약관 메뉴에 공시됩니다. 회사는 본 약관을 수시로 개정 할 수 있으며
          변경 사유가 발생할 경우에는 언제든지 약관을 변경할 권리를 보유합니다. 다만 회원에게 불리하게 약관 내용을
          변경하는 경우에는 약관 적용일자 30일 전부터 적용일자 전일까지 공지한 것 외에 이메일 등의 기타의 전자적 수단을
          통해 통지합니다.
        </li>
        <li>
          약관의 변경 사항은 어플리케이션 &gt; 설정 &gt; 이용약관 메뉴에 공시하며, 7일이 경과한 날로부터 효력이
          발생합니다.
        </li>
        <li>
          본 약관의 가장 최신 버전이 회사와 회원 간의 관계를 규율합니다. 회원은 개정사항이 발효한 이후 본 서비스를
          계속해서 접근 및 이용함으로써 개정된 본 약관에 동의한 것으로 간주합니다. 다만 회원은 변경된 약관에 동의하지
          않을 경우 이용계약을 해지할 수 있습니다.
        </li>
        <li>개정된 약관 공시 내용을 알지 못해 발생하는 불이익이나 손실에 대해서는 회사에서 책임지지 않습니다.</li>
        <li>
          유료서비스를 이용하는 회원이 본 약관의 개정에 동의하지 아니하여 이용계약을 해지하는 경우에는 본 약관 제 12조
          (유료서비스 청약 철회 및 환불) 관련 환불정책을 따릅니다.
        </li>
        <li>
          페이스북, 트위터, GMAIL 등 본 서비스와 회원체계가 연동되어 있는 서비스를 통해 회원가입 및 로그인을 한 경우,
          개인 정보 및 회원체계 관리와 관련한 회원과 회사간의 권리, 의무 및 책임사항 등은 회원이 회원체계를 연동한 각
          서비스 별 약관의 내용을 따릅니다.
        </li>
        <li>
          본 약관에 명시되지 아니한 사항에 대하여는 ‘전기통신기본법’ , ‘전기통신사업법’ , ’정보통신망 이용촉진 및
          정보보호 등에 관한 법률’ ‘(이하 ‘정통망법’), 개인정보보호법, 기타 관련 법령에 따릅니다.
        </li>
      </ol>
      본 약관은 회원과 대한민국 서울특별시 서초구 강남대로 343 신덕빌딩 11층에 한국 지사를 설립한 한국 기업인 Vlending
      Co., Ltd 간의 계약입니다.
      <br />
      <br />
      <b>제 7조 계약사항의 변경</b>
      <ol>
        <li>회원은 개인정보 관리 화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.</li>
        <li>
          회원은 회원 가입 시 접수된 아이디를 변경 할 수 없습니다. 한번 생성한 ID는 변경할 수 없으며, ID의 비밀번호는
          서비스 어플리케이션의 비밀번호 변경 또는 비밀번호 변경 안내 메일을 통해 변경이 가능합니다.
        </li>
        <li>
          접수한 개인정보를 분실하거나 허위 정보를 등록하여 발생할 수 있는 불이익은 본인의 책임이며 회사에서 책임지지
          않습니다.
        </li>
      </ol>
      <br />
      <b>제 8조 광고의 게재</b>
      <br />
      회사는 서비스에 회사 또는 제3자의 광고를 게재할 수 있습니다.
      <br />
      <br />
      <b>제 9조 유료 서비스 이용 계약</b>
      <ol>
        <li>
          회사가 제공하는 서비스는 무료서비스와 유료서비스가 있습니다. 회사가 제공하는 별도의 유료서비스에 대하서는 해당
          정보에 명시된 요금을 지불하여야 사용 가능합니다.
        </li>
        <li>
          회원은 유료서비스 이용계약을 체결하기 전에 해당 유료서비스에 대하여 이 약관에서 회사가 명시, 고지하는 사항을
          숙지하고, 착오 없이 정확히 거래 할 수 있도록 하여야 합니다.
        </li>
        <li>
          회원은 어플리케이션 스토어 결제방식을 통하여 회사가 서비스하는 유료서비스를 이용할 수 있습니다. 회사와 회원간
          유료서비스 이용계약은 회사의 승낙이 있는 때(유료서비스의 “구매/결제완료 등”의 표시가 회원에게 절차상 표시된
          시점)에 성립 합니다.
        </li>
        <li>
          회사는 다음 각 호에 해당하는 경우, 이용신청을 승낙하지 아니하거나 소정의 조건 성취 또는 제한 사유가 해소될
          때까지 일정 기간 동안 승낙을 유보할 수 있습니다.
          <ol>
            <li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
            <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
            <li>허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
            <li>
              회사에 서비스 이용료 등을 납부하지 아니하여 이용계약이 해지된 자가 체납된 이용료를 납부하지 아니한 경우
            </li>
            <li>공공의 안녕질서 및 미풍양속을 해할 우려가 있는 경우</li>
            <li>설비에 여유가 없거나 기술상 서비스 제공이 어려운 경우</li>
            <li>회원의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
          </ol>
        </li>
        <li>
          회사는 유료서비스를 이용하는 회원의 거래 금액에 대하여 내부정책 및 외부 결제업체 기타 관련 법령에 따라 회원
          당원 누적 결제액, 결제한도 등의 거래한도를 정할 수 있으며, 회원은 회사가 정한 거래한도를 초과하는 범위의
          유료서비스를 이용하고자 할 경우 거래 한도의 초과로 인하여 유료서비스의 추가 이용이 불가능할 수 있습니다.
        </li>
      </ol>
      <b>제 10조 유료서비스 이용</b>
      <ol>
        <li>
          회사가 유료회원의 이용신청을 승낙한 때(일부 서비스의 경우, 이용 신청 접수 후 사전 공지한 지정된 일자)로부터
          유료서비스는 개시되며, 회사의 기술적 사유 등 기타 사정에 의하여 유료서비스를 개시할 수 없는 경우에는 제
          6조(약관의 효력 및 변경)의 방법에 따라 회원에게 사전 공지합니다.
        </li>
        <li>
          회사는 회원의 유료서비스 이용신청이 있게 되는 경우, 해당 회원에게 이용신청의 내용을 통지합니다. 회사의 통지를
          받은 회원은 의사표시의 불일치 등이 있는 경우 회사에 정정 또는 수정을 요청하여야 하며, 회사는 회원의 요청에
          따라 처리하여야 합니다. 다만, 이미 대금을 지불한 경우에는 이 약관의 청약 철회 등에 관한 규정에 따릅니다
        </li>
        <li>
          회사는 아래와 같은 유료서비스를 제공하며, 회사의 사정, 기타 제반 여건에 따라 서비스 내용을 추가하거나 변경할
          수 있습니다.
          <ol>
            <li>
              정기결제형 이용권: 유료회원이 미리 등록한 결제수단을 통하여 월 단위로 이용요금이 자동으로 결제되고
              이용기간이 자동 갱신되는 서비스
            </li>
            <li>기간만료형 이용권: 이용 가능 기간이 만료되는 경우, 유료서비스의 이용이 종료되는 서비스</li>
            <li>
              유료 충전 상품 : 회사 및 제3자가 시행하는 기타 거래 동의, 약정, 조건 이행을 위해 사용하는 비트 충전 상품
            </li>
          </ol>
        </li>
        <li>
          유료회원이 유/무선네트워크를 통하여 서비스에 접속하거나 유/무선네트워크가 연결된 상태의 기기 내에 탑재된
          어플리케이션을 통하여 제반 서비스를 이용하는 경우, 유료회원과 유료회원이 가입한 해당 통신사간에 체결된 통신
          요금제에 의한 별도의 데이터 통화료가 발생합니다. 이 경우 발생하는 데이터 통화료는 유료회원과 해당 통신사간에
          체결된 통신요금제에 따라 과금/청구/수납되므로, 데이터 통화료에 대해서는 회사는 어떠한 책임도 지지 않습니다.
        </li>
        <li>
          컨텐츠의 권리를 보유하고 있는 개인, 단체, 법인(‘권리자 등’) 간의 계약의 체결 여부 및 개별 계약의 내용, ‘권리자
          등’의 사후 요청에 따라 컨텐츠의 이용이 제한되거나 변경될 수 있습니다. 회사는 ‘권리자 등’의 요청이 있게 되는
          경우, 해당 요청에 따라 유료서비스를 지원하는 기기의 종류, 회원별 이용 가능 기기 대 수 등을 변경할 수 있습니다.
        </li>
      </ol>
      <b>제 11조 유료서비스 가액 변경</b>
      <br />
      회사는 운영상, 기술상의 필요에 따라 공급하는 유료서비스 가액, 비트 충전을 위한 유료 상품 충전 상품 구매, 기타 유료
      아이템 구매 등을 변경 및 추가 할 수 있으며, 제 6조(약관의 효력 및 변경)의 방법에 따라 유료회원에게 사전
      공지합니다.
      <br />
      <br />
      <b>제 12조 유료서비스 청약 철회 및 환불</b>
      <ol>
        <li>
          유료회원은 해당 유료서비스를 전혀 사용하지 아니하였을 경우에 한하여 결제일로부터 7일 이내에 청약을 철회할 수
          있으며 아래 같은 경우에는 결제 취소 및 환불이 제한됩니다.
          <ol>
            <li>
              결제를 통하여 획득한 서비스 이용권, 쿠폰, 비트(보너스 포함) 등을 전부 또는 부분적으로 이미 사용한 경우
            </li>
            <li>결제를 통해 구매한 이용권 중 즉시 사용이 시작되거나 서비스에 바로 적용 되는 경우</li>
            <li>회원의 단순 과실로 인하여 결제가 이루어진 경우</li>
          </ol>
        </li>
        <li>
          유료회원이 유료서비스에 대하여 전혀 사용하지 아니하였더라도, 청약 철회 가능한 기간(결제일로부터 7일 이내)을
          경과하여 청약 철회를 신청하였을 때 환불은 불가능합니다.
        </li>
        <li>
          회원이 이미 결제한 유료 서비스 이용 계약을 해제, 해지 했을 때, 계약 후 남은 계약 기간 동안 유료서비스를 이용할
          수 있습니다.
        </li>
        <li>환불은 회사 또는 각 어플리케이션 스토어의 환불 운영정책에 따라 진행 됩니다.</li>
        <li>
          회원은 전자우편을 통하여 청약철회 또는 환불을 요구할 수 있으며, 회사는 구매대금의 환불을 위하여 구매 내역을
          확인한 후 추가적인 증빙을 요구할 수 있습니다.
        </li>
        <li>
          청약철회 또는 환불의 원인이 회사의 서비스 폐지 등 회사의 귀책사유로 인한 경우에는 구매대급금의 환불에 따른
          비용은 회사가 부담합니다. 다만 이러한 경우 이외에는 이용자가 유료서비스 이용으로 얻은 이익 및 환불에 따른
          수수료를 공제하고 환불합니다.
        </li>
        <li>
          회원이 유료서비스를 선물 받거나, 프로모션 등을 통해 무료/무상으로 취득하는 등 회원이 직접 비용을 지불하지
          아니하고 이용하는 유료서비스에 대하여 회사는 회원에게 유료서비스 결제 대금을 환불할 의무를 부담하지 않습니다.
        </li>
        <li>
          미성년자가 법정 대리인의 동의 없이 결제 한 경우, 본인 또는 법정대리인은 결제 취소할 수 있습니다. 다만
          미성년자가 속임수로써 자기를 성년자로 믿게 하거나 법정대리인의 동의가 있는 것으로 믿게 한 경우에는 취소할 수
          없습니다.
        </li>
        <li>
          유료회원의 신청 또는 동의에 따라 월 정기결제 중인 유료서비스의 경우, 해당 회원이 유료서비스의 이용요금을
          체납하는 경우 연체가 발생한 날 자동으로 이용권 해지가 될 수 있으므로, 유료서비스를 유지하고자 하는 유료회원은
          이용요금의 체납 또는 결제수단의 연체가 발생하지 않도록 사전에 조치하여야 합니다.
        </li>
        <li>
          유료서비스를 이용 중인 유료회원이 탈퇴하는 경우 해당 이용권은 즉시 해지되며 환불은 불가능합니다. 이 경우
          유료회원의 정보와 뮤빗 서비스 이용 내용은 뮤빗 약관 및 이 약관에 따라 처리됩니다.
        </li>
        <li>
          동일한 사유 또는 유형의 청약철회/환불을 반복적으로 요청하거나, 정당하지 않은 사유로 청약철회/ 환불을 지속하는
          경우 서비스 이용에 제약이 있을 수 있습니다.
        </li>
        <li>
          청약철회/ 환불이 완료 되면 해당 구매 품목에 대한 회수가 진행 되며, 비트로 사용된 품목도 무효처리 되고, 품목을
          제한 혹은 수정 할 수 있습니다.
        </li>
      </ol>
      <br />
      <b>제 13조 유료서비스 정지, 중단</b>
      <ol>
        <li>회사는 원칙적으로 연중무휴 1일 24시간 유료서비스를 제공합니다.</li>
        <li>
          회사는 이용자에 대한 서비스 개선을 목적으로 하는 설비 점검 및 보수 시에는 서비스 전부 또는 일부의 제공을 제한,
          중지, 중단할 수 있습니다. 이 경우 회사는 가능한 한 그 중단사유, 중단 기간 등을 이 약관 제 6조(약관의 효력 및
          변경)의 방법을 통하여 사전에 회원에게 공지하며, 다음 각 호의 경우에는 경위와 원인이 확인된 즉시 사후에 공지할
          수 있습니다.
          <ol>
            <li>회원, 기타 불특정 제3자의 불법, 범죄행위로 인하여 기술적으로 정상적인 서비스의 제공이 어려운 경우</li>
            <li>
              시스템 또는 기타 서비스 설비의 장애, 유무선 Network 장애 또는 유료서비스 이용의 폭주 등으로 정상적인
              유료서비스 제공이 불가능할 경우
            </li>
            <li>기타 천재지변, 국가비상사태, 정전 등 회사가 통제할 수 없는 불가항력적 사유로 인한 경우</li>
          </ol>
        </li>
        <li>
          회사의 귀책사유로 서비스의 제공이 중단됨으로 인하여 회원이 입은 손해에 대하여 뮤빗 서비스 운영 정책에 따라
          소정의 혜택을 드립니다. 다만, 천재지변 등 불가항력으로 인한 경우는 아래 이용중지 또는 장애발생 시간에 산입하지
          아니합니다.
        </li>
        <li>
          회사는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책, 운영상의 긴요한 사유로 수정, 중단, 변경할 수
          있으며, 이에 대하여 관련 법령에 별도 규정이 있지 아니하는 한 별도의 보상을 하지 않습니다.
        </li>
      </ol>
      <b>제 14조 회사의 의무</b>
      <br />
      <ol>
        <li>회사는 특별한 사정이 없는 한 회원이 서비스 이용을 신청한 날에 서비스를 이용할 수 있도록 합니다.</li>
        <li>
          회사는 회원으로부터 소정의 절차에 의해 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 적절한 절차를 거쳐
          처리하여야 합니다. 처리시 일정 기간이 소요될 경우 회원에게 그 사유와 처리 일정을 일러주어야 합니다.
        </li>
        <li>
          회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 이용자의 계약 관련 절차 및 내용 등에 있어 이용자에게 편의를
          제공하도록 노력합니다.
        </li>
        <li>회사는 서비스에 대한 모든 권리를 보유 합니다.</li>
      </ol>
      <b>제 15조 서비스 변경 및 중지</b>
      <ol>
        <li>회사는 운영상 및 기술상 필요에 따라 서비스의 전부 또는 일부 변경할 수 있습니다.</li>
        <li>
          서비스의 내용의 변경이 회원의 권리와 의무에 중대한 영향을 미치는 경우에는 제6조에 따른 공지 및 통지의 절차를
          거쳐 변경을 합니다.
        </li>
        <li>
          회사는 서비스의 제공 시 필요한 경우 정기점검을 실시할 수 있으며, 정기 점검이 실시되는 과정에서 서비스의 제공을
          일시적으로 중단할 수 있습니다.
        </li>
        <li>
          회사는 국가비상상태, 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 있는 경우
          서비스의 제공을 제한하거나 중단할 수 있습니다.
        </li>
        <li>회사는 회사의 경영상의 이유 등의 사유로 서비스를 중단할 수 있습니다.</li>
      </ol>
      <b>제 16조 회원의 권리 및 의무</b>
      <ol>
        <li>
          회원은 ‘서비스’를 통해 회원에게 제공되는 VOD 등 컨텐츠(이하 ‘컨텐츠’)를 개인적, 비영리적으로 시청하고, 게시글,
          댓글, 공유, 참여 등 회사가 서비스를 통해 허용하는 행위를 할 수 있습니다.
        </li>
        <li>
          회원은 전 항의 제한된 권리 외에 서비스를 통하여 제공 받은 ‘컨텐츠’에 대해 어떠한 권리도 취득하지 않습니다.
        </li>
        <li>
          회원은 ‘컨텐츠’를 아래와 같이 본조에 의해 허락 받은 범위를 넘어서서 이용하는 행위를 해서는 안되며, 이와 같은
          행위를 할 경우 그에 대한 모든 민형사상 법적 책임을 집니다.
          <ol>
            <li>컨텐츠를 이용하여 임의로 별도의 동영상 파일 등으로 제작하는 행위</li>
            <li>컨텐츠를 임의로 인터넷에 게시하는 행위</li>
            <li>컨텐츠를 임의로 제3자에게 제공하는 행위</li>
            <li>기타 ‘컨텐츠’에 대해 저작권 및 기타 지적 재산권 법률을 침해하는 행위</li>
          </ol>
        </li>
        <li>
          회원은 서비스의 서버와 네트워크 시스템에 허락되지 않은 방식으로 접근하는 일체의 행위 또는 서비스의 제공을
          방해하는 행위를 해서는 안됩니다.
        </li>
        <li>
          회원은 다음과 같은 행위를 해서는 안됩니다.
          <ol>
            <li>회사에 허위정보를 제공하거나 타인의 정보를 도용하는 행위</li>
            <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해 행위</li>
            <li>회사와 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
            <li>회사의 동의 없이 서비스를 영리적으로 사용하는 행위</li>
            <li>서비스와 관련하여 회사를 사칭하거나 허위정보를 유표한 행위</li>
          </ol>
        </li>
        <li>
          회원은 ‘서비스’를 부정 이용하여 회사가 부정 이용을 금지 또는 시정 요청하였으나 시정 되지 않을 경우 회원은
          회사가 일방적으로 ‘서비스’ 이용 정지나 회원 강제 탈퇴, 기타 정지를 시키더라도 이의 제기하지 않기로 동의합니다.
        </li>
      </ol>
      <b>제 17조 회원의 게시물</b>
      <br />
      회사는 회원이 서비스 내에서 작성, 게시하거나 등록한 문자, 문서, 그림, 음성 또는 이들의 조합으로 이루어진 정보
      등(이하 ‘게시물’)이 아래 정책에 해당한다고 판단되는 경우에 사전 통지없이 삭제하거나 이동 또는 등록을 거부할 수
      있습니다.
      <br />
      회원은 서비스 이용 및 관련 법률, 규칙 및 규정 준수를 포함하여 서비스를 업로드하고 제공하는 모든 컨텐츠에 대한
      책임이 있습니다. 회원은 다른 사람과 편안하게 공유할 수 있는 컨텐츠만 제공해야 합니다. 회원은 본 서비스를 통해
      게시되거나 서비스를 통해 취득하는 모든 컨텐츠 또는 자료의 이용 또는 신뢰에 대한 위험을 스스로 부담합니다. 회사는
      본 서비스를 통해 게시되는 게시물 또는 커뮤니케이션의 완전성, 진실성, 정확성 또는 신뢰성을 지지, 지원, 대변 또는
      보증하거나 본 서비스를 통해 표출된 어떠한 의견도 지지하지 않습니다. 회원은 본 서비스를 이용함으로써 불쾌하거나
      유해하거나 부정확하거나 어떤 식으로든 부적절하다고 판단될 만한 컨텐츠에 노출될 수 있으며, 경우에 따라서는 허위의
      제목으로 등록되었거나 기만적인 게시물에 노출될 수도 있음을 이해해야 합니다. 모든 컨텐츠는 해당 컨텐츠를 게시 한
      사람의 단독 책임입니다.
      <ol>
        <li>타인 (‘회사’ 및 ‘컨텐츠’의 출연자 및 게시자 포함)의 명예를 훼손하거나 근거 없이 비방하는 내용</li>
        <li>공공질서 및 미풍양속에 위반되는 내용인 경우</li>
        <li>범죄적 행위에 결부된다고 인정되는 내용일 경우</li>
        <li>회사 또는 타인의 저작권 기타 법률상 보호받는 권리를 침해하는 내용인 경우</li>
        <li>회사에서 규정한 게시기간을 초과한 경우</li>
        <li>회원이 게시판에 음란물을 게재하거나 음란 사이트를 링크하는 경우</li>
        <li>회사에서 정한 게시물 작성 및 게시 원칙에 어긋나거나 게시판의 성격에 부합하지 않는 게시물의 경우</li>
        <li>회사의 정상적인 서비스 운영을 방해하는 경우</li>
        <li>영리를 목적으로 하는 광고성 내용인 경우</li>
        <li>기타 관련 법령에 따라 게시가 금지된 불법적인 내용인 경우</li>
      </ol>
      회원의 게시물이 “정보통신망의 이용촉진 및 정보보호 등에 관한 법률”, “저작권법” , “개인정보보호법” , 기타 관련
      법령에 위반되는 내용을 포함하는 경우, 관리자는 관련 법령이 정한 절차에 따라 해당 게시물의 게시 중단 또는 삭제 등을
      요청할수 있으며, 회사는 관련 법령에 정해진 바에 따른 조치를 취합니다.
      <ol>
        <li>
          본조의 위반사항이 확인되거나 일정 횟수 이상의 신고를 받은 게시물은 자동적으로 임시 삭제 조치가 취해지며, 해당
          게시물을 작성한 회원은 제 17조 (회원의 게시물)의 위반 사유에 해당하지 않음을 소명하여 해당 조치를 해제할 수
          있습니다.
        </li>
        <li>
          본조의 위반사항을 지속적으로 위반하는 회원은 게시물 작성이 제한되며, 해당 회원은 해당 기간 내에 자신이 작성한
          게시물이 제 17조 (회원의 게시물)의 위반사항에 해당되지 않았음을 소명하여 해당 제한 조치를 해제할수 있습니다.
        </li>
        <li>
          본조의 위반사항을 지속적으로 위반한 회원은 서비스와 회원을 보호하기 위해서 최장 90일 이내의 일정기간 동안
          서비스를 이용할 수 없게 조치될 수 있습니다.
        </li>
        <li>
          게시물 삭제를 위한 신고횟수와 회원의 게시중단 등을 판단할 일정횟수, 서비스 이용중지 기간은 서비스 운영과정에서
          적절한 횟수로 수시로 정해지게 되며, 이 부분에 대한 이의 제시는 서비스의 제공 기능이나 support@mubeat.tv를 통해
          가능합니다.
        </li>
      </ol>
      <b>제 18조 게시물의 저작권</b>
      <br />
      서비스에 대한 저작권 기타 지적재산권은 회사에 귀속 되며 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의
      저작자에게 귀속됩니다. 단 회사가 제공하는 서비스를 통해 뮤빗 컨텐츠 일부 내용을 직접 게시하는 경우에는 회사에 해당
      게시물의 저작권이 귀속됩니다.
      <br />
      회원이 서비스 내에 게시한 게시물 또는 게시물에 포함된 자료 등에 대하여 회사는 게시자의 동의없이 이를 서비스의 제공
      및 이용 이외의 영리적 목적으로 사용할 수 없습니다. 단 회사가 제공하는 서비스를 통해 뮤빗 컨텐츠 일부 내용을 직접
      게시하는 경우, 회사는 해당 게시물을 이용하여 영리적 행위를 할 수 있습니다.
      <br />
      회원이 작성한 컨텐츠에 대한 제한적 사용권의 부여:
      <ol>
        <li>
          회사는 서비스의 프로모션 및 홍보 등을 위하여 필요할 경우 회원 컨텐츠를 사용할 수 있습니다. 또한 회원은 회사가
          서비스 내에서 게시물을 서비스하기 위해 번역, 기술상의 수정, 공유, 재발행 등의 기능을 제공 할 수 있는 권한을
          부여합니다. 이 권한은 게시물의 소유권에는 영향을 미치지 않습니다.
        </li>
        <li>
          회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 서비스에 게재되거나 서비스를 통해 제공된 자료를
          상업적으로 사용할 수 없습니다.
        </li>
        <li>회원이 작성한 게시물에 제3자 웹사이트 또는 서비스에 대한 링크 또는 연결이 포함 될 수 있습니다.</li>
        <li>
          회사는 제3자 웹사이트 또는 서비스에 대한 링크를 통제하지 않으며 회원이 제3자 웹사이트 또는 서비스에 대한
          링크를 사용함으로써 발생하는 모든 부분은 책임지지 않습니다.
        </li>
      </ol>
      <b>제 19조 팬덤 광고 서비스 및 팬덤 광고 사용자 등록 컨텐츠의 관리</b>
      <ol>
        <li>
          회원은 팬덤 광고 서비스에 제공한 회원의 팬덤 광고 사용자 등록 컨텐츠와 관련하여 저작권, 인격권 등 제3자와의
          분쟁 발생시 그 법정 대응 및 결과에 대한 책임을 지며, 회사는 해당 컨텐츠와 관련 된 일체의 책임을 명시적으로
          부인합니다.
        </li>
        <li>
          회사는 회원이 등록한 팬덤 광고 사용자 등록 컨텐츠를 검색 사이트나 다른 사이트에 노출할 수 있으며 판촉, 홍보 및
          기타의 자료로 무상으로 사용 할 수 있습니다. 또한 회사가 제공하는 서비스 내에서 회원 게시물을 복제, 전시, 전송,
          배포할 수 있으며 2차적 저작물과 편집저작물로 작성 할 수 있습니다. 다만 해당 팬덤 광고 사용자 등록 컨텐츠을
          등록한 회원이 게시물의 삭제 또는 사용중지를 요청하면 회사는 관련 법률에 따라 보존해야 하는 사항을 제외하고
          삭제 또는 사용을 중지합니다.
        </li>
        <li>
          &apos;회사&apos;는 &apos;팬덤 광고 서비스&apos;를 통한 저작권 침해행위나 지적재산권 침해를 허용하지 아니하며,
          &apos;회원&apos;의 &apos;팬덤 광고 사용자 등록 컨텐츠&apos;가 타인의 지적재산권을 침해한다는 사실을 적절하게
          고지받거나 인지하게 되는 경우 저작권법 기타 관련 법령에서 정한 절차에 따라 그 &apos;팬덤 광고 사용자 등록
          컨텐츠&apos; 서비스를 중지하거나 제거할 수 있습니다. 또한 &apos;회사&apos;는 &apos;회원&apos;의 &apos;팬덤
          광고 사용자 등록 컨텐츠&apos;가 &apos;팬덤 광고 서비스&apos; 운영 상의 문제가 있다고 판단하는 경우 사전통지
          없이 삭제하거나 이동 또는 등록 거부할 수 있는 권리를 보유합니다.
        </li>
        <li>
          &apos;회사&apos;는 &apos;회원&apos;이 본 서비스의 기능인 &apos;팬덤 광고 서비스&apos;에서 상품을 구매할 때
          이용약관에 동의함으로써 &apos;회원&apos;이 등록하는 &apos;팬덤 광고 사용자 등록 컨텐츠&apos;를 수집하거나 광고
          또는 &apos;팬덤 광고 서비스&apos; 목적에 따라 이벤트 용도로 사용할 수 있습니다.
          <br />
          이용자가 등록하는 사진이나 그래픽 자료는 타인의 저작권, 상표권, 그리고 초상권(퍼블리시티권)과 같이 제3자의
          권리를 침해하지 않는 자료를 사용해야 되며, 관리자 판단에 따라 등록된 사진이 다음과 같을 경우를 포함하고 있을
          시, 이용약관에 준수하여 이용자가 올린 이미지가 아닌 회사가 선정한 기본 이미지로 최종 반영됩니다.
        </li>
        <li>
          팬덤 광고 사용자 등록 컨텐츠가 다음 각 호에 해당하는 경우에는 사전 통지없이 삭제할 수 있습니다. 그러나 회사가
          게시물을 검사 또는 검열할 의무를 부담하는 것은 아닙니다.
          <ol>
            <li>다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</li>
            <li>공공질서 및 미풍양속에 위반되는 내용인 경우</li>
            <li>범죄적 행위에 결부된다고 인정되는 내용인 경우</li>
            <li>회사의 저작권, 제3자의 저작권등 기타 권리를 침해나는 내용인 경우</li>
            <li>회원이 회사의 홈페이지와 게시판에 음란물을 게재하거나 음란 사이트를 링크하는 경우</li>
            <li>광고글 또는 광고글과 유사한 성격의 글이라고 판단되는 경우</li>
            <li>기타 관계법령에 위반된다고 판단되는 경우</li>
            <li>&apos;팬덤 광고 서비스&apos; 취지에 맞지 않을 경우</li>
          </ol>
        </li>
        <li>
          본 약관이 정하는 바에 따라 &apos;회사&apos; 혹은 &apos;회사&apos;가 지정한 자에게 &apos;팬덤 광고 사용자 등록
          컨텐츠&apos;에 대한 사용 권한을 부여합니다. &apos;회사&apos;가 &apos;회원&apos;의 &apos;팬덤 광고 사용자 등록
          컨텐츠&apos;를 사용하는 용도와 방법은 아래와 같습니다.
          <ol>
            <li>
              &apos;팬덤 광고 서비스&apos; 상품을 구매한 &apos;회원&apos;이 &apos;팬덤 광고 서비스&apos;에 제공한
              &apos;팬덤 광고 사용자 등록 컨텐츠&apos;를 수집하여 &apos;팬덤 광고 이미지&apos;로 창작할 수 있음.
            </li>
            <li>
              &apos;팬덤 광고 서비스&apos;에 제공한 &apos;팬덤 광고 사용자 등록 컨텐츠&apos;로 완성된 &apos;팬덤 광고
              이미지&apos;를 불특정 다수가 확인 할 수 있도록 공개할 수 있음.
            </li>
          </ol>
        </li>
      </ol>
      <b>제 20조 광고게재 및 광고주와의 거래</b>
      <ol>
        <li>
          회사는 회사가 운영하고 관리하는 서비스 제공영역 (모바일 및 웹페이지 포함), 회원에게 보내는 메일, 기타 서비스의
          제공과정에서 배너 광고, 게시물 광고, 동영상 광고 등의 형태로 광고를 게재할 수 있습니다.
        </li>
        <li>
          제1항에 따라 이루어진 광고주의 판촉활동에 대하여 회원은 자신의 책임하에 그러한 판촉활동에 참여하거나 거래하며,
          회사는 광고주와 회원 사이의 거래 및 교섭 과정에서 발생하는 일방 당사자의 손해 또는 손실에 대하여 책임을
          부담하지 아니합니다.
        </li>
      </ol>
      <b>제 21조 이용제한</b>
      <br />
      회사는 다음의 경우 회원의 서비스 이용을 일시적 또는 영구적으로 제한할 수 있습니다.
      <ol>
        <li>회원이 제 16조 (회원의 권리 및 의무) 회원의 권리 및 의무를 위반하는 경우</li>
        <li>회원 개인 정보를 허위로 입력하였을 경우</li>
        <li>영리적 목적을 위하여 서비스를 사용하거나 타인의 서비스 이용을 방해한 경우</li>
        <li>타인에게 ID와 비밀번호를 양도, 대여하거나 매매한 경우</li>
        <li>
          허가 없이 서비스 클라이언트 프로그램을 변경하거나 서버를 해킹하는 행위 및 어플리케이션 일부 또는 전부를
          변경하는 행위를 한 경우
        </li>
        <li>회사의 서비스 운영을 고의로 방해한 경우</li>
        <li>저작권자의 허가 없이 저작권 문제가 발생할 소지가 있는 내용을 온라인상에 게재하는 경우</li>
        <li>회원으로서 알게 되는 서비스의 고유 정보를 회사의 허가 없이 상업적인 목적으로 사용하는 경우</li>
        <li>제 17조(회원의 게시물)과 관련한 위반사항이 발생하여 이용 중지가 필요하다고 판단된 경우</li>
        <li>
          회사는 [정보통신망 이용촉진 및 정보보호 등에 관한 법률] 및 동법 시행령에 따라 연속하여 1년 동안 서비스를
          이용하지 않은 회원의 개인정보를 보호하기 위해 계정을 분리하여 해당 계정의 이용을 중지할수 있습니다. 이 경우,
          회사는 휴면계정 처리 예정일로 부터 30일 이전에 해당 사실을 메일 의 방법으로 사전 통지 합니다. 휴면 계정으로
          전환된 이용자는 본인확인 및 휴면 계정해제 절차를 통해 정상적으로 서비스 이용이 가능합니다.
        </li>
      </ol>
      <b>제 22조 서비스 이용 중단</b>
      <br />
      회원은 계정을 비활성화하고 하고 본 서비스의 이용을 중단함으로써 회사와의 체결한 법적 계약을 언제든지 해지할 수
      있습니다. 회원은 서비스의 이용 중단을 위해서 뮤빗 APP &gt; 마이페이지 &gt; 설정 &gt; FAQ &gt; 회원 탈퇴 또는
      언제든지 support@mubeat.tv 로 연락하여 요청할 수 있습니다.
      <br />
      단 서비스 이용을 중단 한 후 회원이 제공한 정보에 대한 사용은 아래와 같습니다.
      <br />
      계정 해지로 인해 회원의 계정과 관련된 모든 컨텐츠가 파괴 될 수 있으므로 회원의 계정을 해지하기 전에 명심 하시길
      바랍니다.
      <br />
      회사는 귀하의 계정 해지 시 회원의 계정에 저장한 게시물 (법률 및 본 이용약관에서 허용하는 한도 내에서)을 조회하거나
      조회하지 않을 수 있습니다. 만약, 저장된 게시물이 조회될 시에 조회 중단 및 파괴를 support@mubeat.tv로 요청하실 수
      있습니다.
      <br />
      회원의 계약 해지 시 비트 등의 잔여 이용, 구매 내역이 남아있는 경우, 이를 신청 전에 소진하여야 합니다. 회사가 잔여
      이용 및 구매 내역 정보를 안내하고 회원탈퇴 시 이를 포함한 서비스 이용정보가 삭제되어 복구가 불가능함을
      확인하였음에도 불구하고 자진 탈퇴한 경우, 회사는 해당 잔여 이용, 구매내역의 복구 등에 대한 일체 책임을 부담하지
      아니합니다.
      <br />본 약관의 종료 후에도 본질 상 효력을 유지해야하는 조항은 해지 후에도 효력을 유지합니다. 예를 들어 다음의
      모든 사항은 이용 해지 후에도 지속됩니다.
      <ol>
        <li>회원이 회사에 지불 등의 책임을 져야 할 의무</li>
        <li>회사의 책임 제한, 소유권 또는 지적 재산권에 관한 조건</li>
        <li>회사와 회원간의 분쟁에 관한 조건</li>
      </ol>
      <b>제 23조 손해배상</b>
      <br />
      회사와 회원은 각자의 귀책에 의해 상대방에 손해를 끼친 경우, 그에 대한 손해배상 책임을 집니다. 특히 회원이 제 16조
      2항을 위반하여 컨텐츠의 저작권을 침해할 경우 회원은 그에 대한 모든 민형사상 책임을 부담합니다.
      <br />
      회사는 제휴사가 취급하는 상품 또는 용역에 대하여 책임을 지지 않습니다.
      <br />
      <br />
      <b>제 24조 면책조항</b>
      <br />
      회사는 서비스를 안정적으로 제공하기 위해 노력하나, 천재지변, 전쟁 및 기타 이에 준하는 불가항력의 경우 중단될 수
      있으며 이에 대해서 회사는 책임을 지지 않습니다
      <br />
      회사는 회원이 컨텐츠를 이용함으로 인해 발생하는 손해에 대해서 회사의 고의 또는 과실 등 귀책이 없는 한 책임지지
      않습니다.
      <br />
      회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 부담하지 아니합니다.
      <br />
      <br />
      <b>제25조 준거법과 재판 관할</b>
      <br />
      회사와 회원간에 제기된 소송에 대해서는 대한민국 법률을 준거법으로 합니다.
      <br />
      회사와 회원 간 발생한 분쟁에 관한 소송은 제소 당시의 회원의 주소에 의하고, 주소가 없는 경우 거소를 관할하는
      지방법원의 전속관할로 합니다. 단, 제소 당시 회원의 주소 또는 거소가 명확하지 아니한 경우의 관할법원은 민사소송법에
      따라 정합니다. 해외에 주소나 거소가 있는 고객의 경우 회사와 고객간 발생한 분쟁에 관한 소송은 대한민국
      서울중앙지방법원을 관할법원으로 합니다.
      <br />
      <br />
      부칙.
      <br />본 약관은 2021년 9월 30일부터 시행합니다.
    </>
  );
};

export default TermsOfServiceKO;
